import React from 'react';
import { observable } from 'mobx';
import { useObserver } from 'mobx-react-lite';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import VisibleIcon from '../assets/eye.inline.svg';
import InvisibleIcon from '../assets/eye-slash.inline.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PasswordInput = function PasswordInput(props) {
  const { value, onChange, label, helperText, ...inputProps } = props;

  const passwordStore = React.useRef(
    observable({
      showPassword: false,
    })
  ).current;

  const handlePasswordChange = (event) => {
    onChange(event.target.value);
  };

  const toggleVisibility = () => {
    passwordStore.showPassword = !passwordStore.showPassword;
  };

  return useObserver(() => (
    <>
      <TextField
        type={passwordStore.showPassword ? 'text' : 'password'}
        value={value}
        onChange={handlePasswordChange}
        fullWidth
        helperText={helperText}
        label={label}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FontAwesomeIcon icon={['fa', 'lock-alt']} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={toggleVisibility}
                edge="end"
              >
                {passwordStore.showPassword ? (
                  <InvisibleIcon style={{ width: '18px' }} />
                ) : (
                  <VisibleIcon style={{ width: '18px' }} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...inputProps}
      />
    </>
  ));
};

export default PasswordInput;
